import { createContext } from "react";

// react-bootstrap 0.31 shares controlId/validationState from FormGroup to
// FormControl/ControlLabel via legacy context; the shim uses a modern one.
export const FormGroupContext = createContext<{
  controlId?: string;
  validationState?: string;
}>({});

// Whether a FormControl is rendered inside an InputGroup (a daisyUI "join"),
// so it can pick up the join-item class.
export const InputGroupContext = createContext(false);
